// ajaxové donačítání obsahu
$(document).ready(function () {
    window.pagerAjax = function () {
        var a = 0;
        $(".js-pager-ajax-next-page-content").delegate(".js-pager-ajax-next-page:not(.loading)", "click", function () {
            var t = $(this), s = $(this).parents(".pages_bottom"), n = $(".js-pager-ajax-content"),
                d = t.data("next-page"), o = t.data("last-page");
            s.addClass("loading"), n.addClass("loading"), 1 === ++a && setTimeout(function () {
                $.ajax({
                    url: t.data("url").replace("%d", d),
                    data: {ajax: 1, "ajax-block": "BOTTOM", "ajax-pager": 1},
                    success: function(data){
                        $(".pages_bottom").find(".pagination-wrapper").html(data);
                    }
                }),
                    $.ajax({
                        url: t.data("url").replace("%d", d),
                        data: {ajax: 1, "ajax-block": "PAGER", "ajax-pager": 1},
                        success: function (a) {
                            history.pushState({page: d}, "title " + d, t.data("url").replace("%d", d));
                            var e = $("<div/>");
                            e.addClass(t.attr("class")), e.addClass("newBtn"), e.data("url", t.data("url")), e.data("last-page", t.data("last-page")), e.data("next-page", parseInt(d) + 1), e.text(t.text()), t.after(e), t.remove(), n.append(a), n.removeClass("loading"), s.removeClass("loading"), d == o && (e.remove(), s.addClass("disabled"), $(".JS-estates-bottom-links").show()), window.nemovitostiOwlCarusel(), window.lazyLoad(), window.matchHeight(), void 0 !== window.pagerOnSuccess && window.pagerOnSuccess(e, n, a)
                        }
                    }),
                    a = 0
            }, 700)
        })
    }, window.pagerAjax(), $(".js-pager-ajax-next-page-content").length || $(".JS-estates-bottom-links").show()
});